export const bestDescribesOptions = [
  { id: "corporation", value: "Corporation" },
  { id: "financial", value: "Financial Services" },
  { id: "government", value: "Government Agency, Public Entity" },
  { id: "nonprofit", value: "Non-Profit" },
  { id: "education", value: "Education" },
  { id: "professional", value: "Professional" },
  { id: "emerging", value: "Small & Emerging Business or Supplier" },
  { id: "other", value: "Other" },
]
export const whichBusinessTypeOptions = [
  {
    id: "company_provider",
    value:
      "Provider – Corporation, Financial Institution or Organization (I would like to provide supplier opportunities, access to capital/funding, mentorship, sponsorship, and/or professional advice)",
  },
  {
    id: "company_seeker",
    value:
      "Seeker – Small & Emerging Business, Supplier or Organization seeking opportunities (I am seeking supplier opportunities, access to capital/funding, mentors, sponsors, and/or professional advice)",
  },
]

export const revenueRangeItems = [
  { id: "under_1m", value: "Under $1M Annually" },
  { id: "1m_5m", value: "$1M to less than $5M Annually" },
  { id: "5m_10m", value: "$5M to less than $10M Annually" },
  { id: "10m_50m", value: "$10M to $50M Annually" },
  { id: "50m_100m", value: "Above $50M to less than $100M Annually" },
  { id: "100m_500m", value: "$100M to less than $500M Annually" },
  { id: "500m_1b", value: "$500M to less than $1B Annually" },
  { id: "1b_5b", value: "$1B to less than $5B Annually" },
  { id: "5b_10b", value: "$5B to less than $10B Annually" },
  { id: "over_10b", value: "$10B+ Annually" },
]

export const financialServicesTypeItems = [
  { id: "banking", value: "Banking" },
  { id: "private_equity", value: "Private Equity" },
  { id: "venture_capital", value: "Venture Capital" },
  { id: "angel_investor", value: "Angel Investor" },
  { id: "debt_financing", value: "Debt Financing" },
  {
    id: "working_capital",
    value: "Working Capital Financing (Acc Rec/PO/Inventory)",
  },
  { id: "merger_acquisition", value: "Merger and Acquisition" },
  { id: "wealth_management", value: "Wealth Management" },
  { id: "family_offices", value: "Family Offices" },
  { id: "initial_public_offering", value: "Initial Public Offering" },
  { id: "other", value: "Other" },
]

export const regionItems = [
  { id: "us", value: "US" },
  { id: "canada", value: "Canada" },
  { id: "europe", value: "Europe" },
  { id: "asia_pacific", value: "Asia-Pacific" },
  { id: "latin_america", value: "Latin America" },
  { id: "middle_east", value: "Middle East" },
  { id: "africa", value: "Africa" },
  { id: "australia", value: "Australia" },
  { id: "other", value: "Other" },
]

export const professionalLevelItems = [
  { id: "ceo_president", value: "CEO/President" },
  { id: "c_level", value: "C- Level (Direct report to CEO or President)" },
  { id: "svp", value: "SVP" },
  { id: "vp", value: "VP" },
  { id: "director", value: "Director" },
  { id: "manager", value: "Manager" },
  { id: "founder", value: "Founder" },
]

export const countryItems = [
  { id: "afghanistan", value: "Afghanistan" },
  { id: "albania", value: "Albania" },
  { id: "algeria", value: "Algeria" },
  { id: "american_samoa", value: "American Samoa" },
  { id: "andorra", value: "Andorra" },
  { id: "angola", value: "Angola" },
  { id: "anguilla", value: "Anguilla" },
  { id: "antarctica", value: "Antarctica" },
  { id: "antigua_and_barbuda", value: "Antigua and Barbuda" },
  { id: "argentina", value: "Argentina" },
  { id: "armenia", value: "Armenia" },
  { id: "aruba", value: "Aruba" },
  { id: "australia", value: "Australia" },
  { id: "austria", value: "Austria" },
  { id: "azerbaijan", value: "Azerbaijan" },
  { id: "bahamas", value: "Bahamas" },
  { id: "bahrain", value: "Bahrain" },
  { id: "bangladesh", value: "Bangladesh" },
  { id: "barbados", value: "Barbados" },
  { id: "belarus", value: "Belarus" },
  { id: "belgium", value: "Belgium" },
  { id: "belize", value: "Belize" },
  { id: "benin", value: "Benin" },
  { id: "bermuda", value: "Bermuda" },
  { id: "bhutan", value: "Bhutan" },
  { id: "bolivia", value: "Bolivia" },
  {
    id: "bonaire_sint_eustatius_and_saba",
    value: "Bonaire, Sint Eustatius and Saba",
  },
  { id: "bosnia_and_herzegovina", value: "Bosnia and Herzegovina" },
  { id: "botswana", value: "Botswana" },
  { id: "bouvet_island", value: "Bouvet Island" },
  { id: "brazil", value: "Brazil" },
  {
    id: "british_indian_ocean_territory",
    value: "British Indian Ocean Territory",
  },
  { id: "brunei_darussalam", value: "Brunei Darussalam" },
  { id: "bulgaria", value: "Bulgaria" },
  { id: "burkina_faso", value: "Burkina Faso" },
  { id: "burundi", value: "Burundi" },
  { id: "cabo_verde", value: "Cabo Verde" },
  { id: "cambodia", value: "Cambodia" },
  { id: "cameroon", value: "Cameroon" },
  { id: "canada", value: "Canada" },
  { id: "cayman_islands", value: "Cayman Islands" },
  { id: "central_african_republic", value: "Central African Republic" },
  { id: "chad", value: "Chad" },
  { id: "chile", value: "Chile" },
  { id: "china", value: "China" },
  { id: "christmas_island", value: "Christmas Island" },
  { id: "cocos_islands", value: "Cocos Islands" },
  { id: "colombia", value: "Colombia" },
  { id: "comoros", value: "Comoros" },
  { id: "congo", value: "Congo" },
  {
    id: "congo_democratic_republic",
    value: "Congo, Democratic Republic of the",
  },
  { id: "cook_islands", value: "Cook Islands" },
  { id: "costa_rica", value: "Costa Rica" },
  { id: "croatia", value: "Croatia" },
  { id: "cuba", value: "Cuba" },
  { id: "curacao", value: "Curaçao" },
  { id: "cyprus", value: "Cyprus" },
  { id: "czechia", value: "Czechia" },
  { id: "cote_divoire", value: "Côte d'Ivoire" },
  { id: "denmark", value: "Denmark" },
  { id: "djibouti", value: "Djibouti" },
  { id: "dominica", value: "Dominica" },
  { id: "dominican_republic", value: "Dominican Republic" },
  { id: "ecuador", value: "Ecuador" },
  { id: "egypt", value: "Egypt" },
  { id: "el_salvador", value: "El Salvador" },
  { id: "equatorial_guinea", value: "Equatorial Guinea" },
  { id: "eritrea", value: "Eritrea" },
  { id: "estonia", value: "Estonia" },
  { id: "eswatini", value: "Eswatini" },
  { id: "ethiopia", value: "Ethiopia" },
  { id: "falkland_islands", value: "Falkland Islands" },
  { id: "faroe_islands", value: "Faroe Islands" },
  { id: "fiji", value: "Fiji" },
  { id: "finland", value: "Finland" },
  { id: "france", value: "France" },
  { id: "french_guiana", value: "French Guiana" },
  { id: "french_polynesia", value: "French Polynesia" },
  { id: "french_southern_territories", value: "French Southern Territories" },
  { id: "gabon", value: "Gabon" },
  { id: "gambia", value: "Gambia" },
  { id: "georgia", value: "Georgia" },
  { id: "germany", value: "Germany" },
  { id: "ghana", value: "Ghana" },
  { id: "gibraltar", value: "Gibraltar" },
  { id: "greece", value: "Greece" },
  { id: "greenland", value: "Greenland" },
  { id: "grenada", value: "Grenada" },
  { id: "guadeloupe", value: "Guadeloupe" },
  { id: "guam", value: "Guam" },
  { id: "guatemala", value: "Guatemala" },
  { id: "guernsey", value: "Guernsey" },
  { id: "guinea", value: "Guinea" },
  { id: "guinea_bissau", value: "Guinea-Bissau" },
  { id: "guyana", value: "Guyana" },
  { id: "haiti", value: "Haiti" },
  {
    id: "heard_island_and_mcdonald_islands",
    value: "Heard Island and McDonald Islands",
  },
  { id: "holy_see", value: "Holy See" },
  { id: "honduras", value: "Honduras" },
  { id: "hong_kong", value: "Hong Kong" },
  { id: "hungary", value: "Hungary" },
  { id: "iceland", value: "Iceland" },
  { id: "india", value: "India" },
  { id: "indonesia", value: "Indonesia" },
  { id: "iran", value: "Iran" },
  { id: "iraq", value: "Iraq" },
  { id: "ireland", value: "Ireland" },
  { id: "isle_of_man", value: "Isle of Man" },
  { id: "israel", value: "Israel" },
  { id: "italy", value: "Italy" },
  { id: "jamaica", value: "Jamaica" },
  { id: "japan", value: "Japan" },
  { id: "jordan", value: "Jordan" },
  { id: "kazakhstan", value: "Kazakhstan" },
  { id: "kenya", value: "Kenya" },
  { id: "kiribati", value: "Kiribati" },
  {
    id: "korea_democratic_peoples_republic",
    value: "Korea, Democratic People's Republic of",
  },
  { id: "korea_republic", value: "Korea, Republic of" },
  { id: "kuwait", value: "Kuwait" },
  { id: "kyrgyzstan", value: "Kyrgyzstan" },
  {
    id: "lao_peoples_democratic_republic",
    value: "Lao People's Democratic Republic",
  },
  { id: "latvia", value: "Latvia" },
  { id: "lebanon", value: "Lebanon" },
  { id: "lesotho", value: "Lesotho" },
  { id: "liberia", value: "Liberia" },
  { id: "libya", value: "Libya" },
  { id: "liechtenstein", value: "Liechtenstein" },
  { id: "lithuania", value: "Lithuania" },
  { id: "luxembourg", value: "Luxembourg" },
  { id: "macao", value: "Macao" },
  { id: "madagascar", value: "Madagascar" },
  { id: "malawi", value: "Malawi" },
  { id: "malaysia", value: "Malaysia" },
  { id: "maldives", value: "Maldives" },
  { id: "mali", value: "Mali" },
  { id: "malta", value: "Malta" },
  { id: "marshall_islands", value: "Marshall Islands" },
  { id: "martinique", value: "Martinique" },
  { id: "mauritania", value: "Mauritania" },
  { id: "mauritius", value: "Mauritius" },
  { id: "mayotte", value: "Mayotte" },
  { id: "mexico", value: "Mexico" },
  { id: "micronesia", value: "Micronesia" },
  { id: "moldova", value: "Moldova" },
  { id: "monaco", value: "Monaco" },
  { id: "mongolia", value: "Mongolia" },
  { id: "montenegro", value: "Montenegro" },
  { id: "montserrat", value: "Montserrat" },
  { id: "morocco", value: "Morocco" },
  { id: "mozambique", value: "Mozambique" },
  { id: "myanmar", value: "Myanmar" },
  { id: "namibia", value: "Namibia" },
  { id: "nauru", value: "Nauru" },
  { id: "nepal", value: "Nepal" },
  { id: "netherlands", value: "Netherlands" },
  { id: "new_caledonia", value: "New Caledonia" },
  { id: "new_zealand", value: "New Zealand" },
  { id: "nicaragua", value: "Nicaragua" },
  { id: "niger", value: "Niger" },
  { id: "nigeria", value: "Nigeria" },
  { id: "niue", value: "Niue" },
  { id: "norfolk_island", value: "Norfolk Island" },
  { id: "north_macedonia", value: "North Macedonia" },
  { id: "northern_mariana_islands", value: "Northern Mariana Islands" },
  { id: "norway", value: "Norway" },
  { id: "oman", value: "Oman" },
  { id: "pakistan", value: "Pakistan" },
  { id: "palau", value: "Palau" },
  { id: "palestine", value: "Palestine, State of" },
  { id: "panama", value: "Panama" },
  { id: "papua_new_guinea", value: "Papua New Guinea" },
  { id: "paraguay", value: "Paraguay" },
  { id: "peru", value: "Peru" },
  { id: "philippines", value: "Philippines" },
  { id: "pitcairn", value: "Pitcairn" },
  { id: "poland", value: "Poland" },
  { id: "portugal", value: "Portugal" },
  { id: "puerto_rico", value: "Puerto Rico" },
  { id: "qatar", value: "Qatar" },
  { id: "romania", value: "Romania" },
  { id: "russian_federation", value: "Russian Federation" },
  { id: "rwanda", value: "Rwanda" },
  { id: "reunion", value: "Réunion" },
  { id: "saint_barthelemy", value: "Saint Barthélemy" },
  { id: "saint_helena", value: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: "saint_kitts_and_nevis", value: "Saint Kitts and Nevis" },
  { id: "saint_lucia", value: "Saint Lucia" },
  { id: "saint_martin", value: "Saint Martin" },
  { id: "saint_pierre_and_miquelon", value: "Saint Pierre and Miquelon" },
  {
    id: "saint_vincent_and_the_grenadines",
    value: "Saint Vincent and the Grenadines",
  },
  { id: "samoa", value: "Samoa" },
  { id: "san_marino", value: "San Marino" },
  { id: "sao_tome_and_principe", value: "Sao Tome and Principe" },
  { id: "saudi_arabia", value: "Saudi Arabia" },
  { id: "senegal", value: "Senegal" },
  { id: "serbia", value: "Serbia" },
  { id: "seychelles", value: "Seychelles" },
  { id: "sierra_leone", value: "Sierra Leone" },
  { id: "singapore", value: "Singapore" },
  { id: "sint_maarten", value: "Sint Maarten" },
  { id: "slovakia", value: "Slovakia" },
  { id: "slovenia", value: "Slovenia" },
  { id: "solomon_islands", value: "Solomon Islands" },
  { id: "somalia", value: "Somalia" },
  { id: "south_africa", value: "South Africa" },
  {
    id: "south_georgia",
    value: "South Georgia and the South Sandwich Islands",
  },
  { id: "south_sudan", value: "South Sudan" },
  { id: "spain", value: "Spain" },
  { id: "sri_lanka", value: "Sri Lanka" },
  { id: "sudan", value: "Sudan" },
  { id: "suriname", value: "Suriname" },
  { id: "svalbard_and_jan_mayen", value: "Svalbard and Jan Mayen" },
  { id: "sweden", value: "Sweden" },
  { id: "switzerland", value: "Switzerland" },
  { id: "syria", value: "Syria Arab Republic" },
  { id: "taiwan", value: "Taiwan" },
  { id: "tajikistan", value: "Tajikistan" },
  { id: "tanzania", value: "Tanzania, the United Republic of" },
  { id: "thailand", value: "Thailand" },
  { id: "timor_leste", value: "Timor-Leste" },
  { id: "togo", value: "Togo" },
  { id: "tokelau", value: "Tokelau" },
  { id: "tonga", value: "Tonga" },
  { id: "trinidad_and_tobago", value: "Trinidad and Tobago" },
  { id: "tunisia", value: "Tunisia" },
  { id: "turkmenistan", value: "Turkmenistan" },
  { id: "turks_and_caicos_islands", value: "Turks and Caicos Islands" },
  { id: "tuvalu", value: "Tuvalu" },
  { id: "turkiye", value: "Türkiye" },
  { id: "us_minor_outlying_islands", value: "US Minor Outlying Islands" },
  { id: "uganda", value: "Uganda" },
  { id: "ukraine", value: "Ukraine" },
  { id: "united_arab_emirates", value: "United Arab Emirates" },
  { id: "united_kingdom", value: "United Kingdom" },
  { id: "united_states", value: "United States" },
  { id: "uruguay", value: "Uruguay" },
  { id: "uzbekistan", value: "Uzbekistan" },
  { id: "vanuatu", value: "Vanuatu" },
  { id: "venezuela", value: "Venezuela" },
  { id: "viet_nam", value: "Viet Nam" },
  { id: "virgin_islands_british", value: "Virgin Islands, British" },
  { id: "virgin_islands_us", value: "Virgin Islands, U.S." },
  { id: "western_sahara", value: "Western Sahara" },
  { id: "yemen", value: "Yemen" },
  { id: "zambia", value: "Zambia" },
  { id: "zimbabwe", value: "Zimbabwe" },
]
